import { createFileRoute, redirect } from "@tanstack/react-router";
import { readWorkspaceNavigation, workspaceNavigationHref } from "@/features/builder/lib/workspaceNavigation";

export const Route = createFileRoute("/builder/")({
  beforeLoad: ({ location }) => {
    throw redirect({ href: workspaceNavigationHref(readWorkspaceNavigation(location.pathname, location.searchStr), location.searchStr, location.hash), replace: true });
  },
});
